var map = {
	"./business.svg": 630,
	"./calendar.svg": 631,
	"./corporation.svg": 632,
	"./description.svg": 633,
	"./domain_disabled.svg": 634,
	"./license.svg": 635,
	"./link.svg": 636,
	"./location.svg": 637,
	"./people.svg": 638,
	"./person.svg": 639,
	"./social-facebook.svg": 640,
	"./social-github.svg": 641,
	"./social-linked-in.svg": 642,
	"./social-twitter.svg": 643,
	"./time.svg": 644,
	"./upload.svg": 645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;